<template>
  <div class="app-shell">
    <NavHeader />
    <div class="app-body">
      <NavSidebar />
      <main class="app-main">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-shell {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}

.app-body {
  display: flex;
  flex: 1;
  min-height: 0;
  align-items: stretch;
}

// The window scrolls, not this element — the header is sticky and the sidebar
// sticks below it, which keeps `window.scrollTo` and mobile address-bar
// collapsing working the way they did before the shell existed.
.app-main {
  flex: 1;
  min-width: 0;
  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
  }
}
</style>
